import { SharedAccountsRepositoryImplementation } from '../infrastructure/shared-accounts-repository-implementation';
import { firstValueFrom } from 'rxjs';
import { OfflineClientPayload } from '../types/accountant';

/**
 * Accountant Service
 * Wrapper for SharedAccounts repository specialized for the Accountant Hub.
 */

const getRepo = () => {
    const uid = localStorage.getItem('user_uid') || '';
    const cid = localStorage.getItem('cid');
    return new SharedAccountsRepositoryImplementation(uid, cid);
};

export const accountantService = {
    getMyInvitations: async () => {
        const repo = getRepo();
        return firstValueFrom(repo.getAccountantInvitations());
    },

    acceptInvitation: async (id: number) => {
        const repo = getRepo();
        return firstValueFrom(repo.acceptInvitation(id));
    },

    rejectInvitation: async (id: number) => {
        const repo = getRepo();
        return firstValueFrom(repo.deleteAccess(id));
    },

    getLinkedCompanies: async () => {
        const repo = getRepo();
        return firstValueFrom(repo.getAccountantLinkedCompanies());
    },

    getFiscalAlerts: async () => {
        const repo = getRepo();
        return firstValueFrom(repo.getFiscalAlerts());
    },

    healGaps: async (companyId: number) => {
        const repo = getRepo();
        return firstValueFrom(repo.healGaps(companyId));
    },

    createOfflineClient: async (payload: OfflineClientPayload) => {
        const repo = getRepo();
        return firstValueFrom(repo.createOfflineClient(payload));
    }
};
